import { Card } from 'antd'
import { createContext, ReactNode, useContext } from 'react'
import VSpace from './VSpace'

export type SectionLayout = 'section' | 'card'

/**
 * Invoicing and visit blocks render as legacy `<section>`s (styled by
 * `.new-billing-sections`) on the job page and classic invoicing screen. Full-page
 * editor drawers provide 'card' so the same blocks render as titled antd Cards.
 */
export const SectionLayoutContext = createContext<SectionLayout>('section')

type Props = {
  title: ReactNode
  children: ReactNode
}

const SectionCard = ({ title, children }: Props) => {
  const layout = useContext(SectionLayoutContext)

  if (layout === 'card') {
    return <Card title={title}>
      <VSpace>{children}</VSpace>
    </Card>
  }

  return <section>
    <VSpace>
      <h4>{title}</h4>
      {children}
    </VSpace>
  </section>
}

export default SectionCard
